/**
 * Created by Xinhe on 2019-08-18.
 */
import DemoPage from "./DemoPage";
export default function DemoPageWrapper(Demo, DemoSource, config) {
  return {
    components: {
      DemoPage
    },
    render() {
      return (
        <DemoPage {...{ props: config }} source={DemoSource}>
          <Demo />
        </DemoPage>
      );
    }
  };
}
